import { render } from "./opted-in-provider-preview.vue?vue&type=template&id=20aef917&scoped=true"
import script from "./opted-in-provider-preview.vue?vue&type=script&lang=js"
export * from "./opted-in-provider-preview.vue?vue&type=script&lang=js"

import "./opted-in-provider-preview.vue?vue&type=style&index=0&id=20aef917&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aef917"]])

export default __exports__